<era-device-grid-ui [devices]="assignedDevices$ | async"
                    (selected)="itemSelected($event)">
  <div class="title d-flex align-items-center">
    <h6>Assigned ({{ devicesCount$ | async }})</h6>
    @if (features.devices.reboot) {
    <div class="ms-auto flex-shrink-1 d-flex align-items-center mb-1">
      <era-context-menu>
        <button ngbDropdownItem
                (click)="openRebootRequest()">Setup reboot</button>
        <button ngbDropdownItem
                (click)="openSyncModalRequest()">Sync devices</button>
      </era-context-menu>
    </div>
    }
  </div>
  <div class="empty">
    <p>No assigned devices.</p>
  </div>
</era-device-grid-ui>